import { reskinStyles } from 'core/components/theme/theme-variant';
import { THEME_VARIANTS } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    marginBottom: theme.spacing(2)
  },
  label: {
    textTransform: 'uppercase',
    fontWeight: 600
  },
  value: {
    minHeight: 20,
    marginTop: theme.spacing(1)
  },
  'dark-label': {
    composes: '$label',
    color: theme.colors.light_text,
    opacity: 0.6
  },
  'dark-value': {
    composes: '$value',
    color: theme.onCard.white
  },
  // For cards that stay dark green in the new look too; `dark` follows the cards that turned light.
  'alwaysDark-label': {
    composes: '$dark-label',
    ...reskinStyles(theme, { color: theme.colorPalette.beige_60, opacity: 1 })
  },
  'alwaysDark-value': {
    composes: '$dark-value',
    ...reskinStyles(theme, { color: theme.colorPalette.white })
  },
  'locked-label': {
    color: theme.colorPalette.beige_60
  },
  'locked-value': {
    color: theme.colors.white
  },
  // New look: quote's locked field (see value-field.jsx).
  lockedLabel: {
    textTransform: 'none',
    fontWeight: 400,
    color: theme.colors.text_secondary
  },
  lockedField: {
    backgroundColor: theme.colorPalette.beige_25,
    border: `1px solid ${theme.colorPalette.beige_60}`,
    borderRadius: 22,
    padding: theme.spacing(1.5, 4),
    color: theme.colors.text_primary,
    '& > *': { justifyContent: 'space-between' }
  },
  lockIcon: {
    // Doubled class: outranks the tooltip's 16px icon size.
    '&&': { width: 24, height: 24, marginLeft: theme.spacing(2) }
  },
  valueFieldTooltip: {
    position: 'relative',
    top: theme.spacing(-1),
    margin: theme.spacing(0, 1)
  },
  copyButton: {
    padding: 2,
    borderRadius: '50%',
    // Reskin: icon-only copy buttons hover like the other icon buttons (bark50), visible on beige rows and panels.
    ...reskinStyles(theme, { '&&:hover': { backgroundColor: theme.colorPalette.orange_on_dark } })
  },
  link: {
    color: `${theme.colors.action_text} !important`,
    cursor: 'pointer',
    textDecoration: 'none',
    ...reskinStyles(theme, theme.actionStyles.link)
  },
  // On dark cards the standard accent is too dark to read; use the light bark tint.
  'dark-link': {
    composes: '$link',
    color: `${theme.themeVariant === THEME_VARIANTS.RESKIN ? theme.colors.action_text : theme.onCard.orange_on_dark} !important`
  }
});

export default makeStyles(styles);
